<div class="intro-box">
  <div class="column column--image"></div>
  <div class="column column--content">
    <div class="intro-text">
      <h2>As cheap as chips and easy as pie</h2>
      <p>
        Keep more of your cash for epic adventures! Enjoy affordable investing on SA’s cheapest platform with low fees,
        and no minimums.
      </p>
    </div>

    <div class="intro-step">
      <eid-intro-stepper [active]="4" (stepSelected)="stepSelected($event)"></eid-intro-stepper>
      <div class="close-text">
        <div (mousedown)="close()" class="skip-btn">
          <span class="text">Skip Intro</span>
        </div>
      </div>
    </div>
  </div>
</div>
